import { Image, Play, FileText, ExternalLink, Phone } from "lucide-react";

const WA_BG_COLOR = "#E5DDD5";

const WA_BG_PATTERN = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80'%3E%3Cg fill='%23c5b9ae' fill-opacity='0.18'%3E%3Cpath d='M0 0h4v4H0zm8 0h4v4H8zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM4 4h4v4H4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zm-4 4h4v4h-4zm-8 0h4v4h-4zm-8 0h4v4h-4zm-8 0h4v4h-4zm-8 0h4v4h-4zm-8 0h4v4h-4zm-8 0h4v4h-4zm-8 0h4v4H0zm40 0h4v4h-4z'/%3E%3C/g%3E%3C/svg%3E")`;

const renderBody = (text) => {
  if (!text) {
    return (
      <span className="text-gray-400 italic" style={{ fontSize: 14 }}>
        Your message body will appear here…
      </span>
    );
  }
  return text
    .replace(/\*(.*?)\*/g, "<strong>$1</strong>")
    .replace(/_(.*?)_/g, "<em>$1</em>")
    .replace(/~(.*?)~/g, "<del>$1</del>")
    .split("\n")
    .map((line, i) => (
      <span
        key={i}
        className="block"
        dangerouslySetInnerHTML={{ __html: line || "&#8203;" }}
      />
    ));
};

const DoubleCheck = () => (
  <svg width="16" height="11" viewBox="0 0 16 11" fill="none" className="inline-block flex-shrink-0">
    <path d="M11.071.5 4.5 7.071 1.929 4.5.5 5.929l4 4 1.414-1.414L12.5 1.929 11.071.5Z" fill="#53bdeb" />
    <path d="M15.071.5 8.5 7.071 7.086 5.657 5.657 7.086l2.843 2.843L16.5 1.929 15.071.5Z" fill="#53bdeb" />
  </svg>
);

const WhatsAppTemplatePreview = ({
  headerType,
  headerValue,
  bodyText,
  footerText,
  buttonType,
  buttonText,
  stopButton,
}) => {
  const time = new Date().toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  const hasButton = (buttonType && buttonType !== "none" && buttonText) || stopButton;

  return (
    <div className="flex flex-col h-full rounded-xl overflow-hidden shadow-sm border border-gray-200 bg-white">

      {/* Card title */}
      <div className="flex-shrink-0 px-5 py-4 bg-white border-b border-gray-100">
        <p className="text-[18px] font-bold text-gray-900">Template preview</p>
      </div>

      {/* WhatsApp chat area */}
      <div
        className="flex-1 min-h-0 overflow-y-auto px-4 py-5"
        style={{
          backgroundColor: WA_BG_COLOR,
          backgroundImage: WA_BG_PATTERN,
          backgroundSize: "80px 80px",
        }}
      >
        {/* Received message bubble (left-aligned, white — customer's view) */}
        <div className="flex items-start" style={{ maxWidth: "88%" }}>
          {/* Tail */}
          <div
            className="flex-shrink-0 mt-0"
            style={{
              width: 0,
              height: 0,
              borderTop: "9px solid white",
              borderRight: "0px solid transparent",
              borderLeft: "9px solid transparent",
              marginTop: 0,
              filter: "drop-shadow(-1px 0px 0.5px rgba(0,0,0,0.08))",
            }}
          />

          {/* Bubble */}
          <div
            className="flex-1 overflow-hidden"
            style={{
              backgroundColor: "white",
              borderRadius: "0 8px 8px 8px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.13)",
            }}
          >
            {/* ── Media Header ── */}
            {headerType === "image" && (
              <div>
                {headerValue instanceof File ? (
                  <img
                    src={URL.createObjectURL(headerValue)}
                    alt="Header"
                    className="w-full object-cover"
                    style={{ maxHeight: 220 }}
                  />
                ) : (
                  <div
                    className="w-full flex flex-col items-center justify-center text-gray-300 bg-gray-100"
                    style={{ height: 180 }}
                  >
                    <Image className="w-10 h-10 mb-1" />
                    <span style={{ fontSize: 12 }}>Image header</span>
                  </div>
                )}
              </div>
            )}

            {headerType === "video" && (
              <div>
                {headerValue instanceof File ? (
                  <video
                    src={URL.createObjectURL(headerValue)}
                    className="w-full object-cover"
                    style={{ maxHeight: 220 }}
                    controls
                  />
                ) : (
                  <div
                    className="w-full flex flex-col items-center justify-center text-gray-300 bg-gray-800"
                    style={{ height: 180 }}
                  >
                    <Play className="w-10 h-10 mb-1" />
                    <span style={{ fontSize: 12 }} className="text-gray-400">Video header</span>
                  </div>
                )}
              </div>
            )}

            {headerType === "document" && (
              <div className="flex items-center gap-3 px-3 pt-3 pb-2 border-b border-gray-100">
                <div className="bg-blue-50 p-2 rounded-lg flex-shrink-0">
                  <FileText className="w-6 h-6 text-blue-500" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-gray-900 truncate" style={{ fontSize: 14 }}>
                    {headerValue instanceof File ? headerValue.name : "Document.pdf"}
                  </p>
                  <p className="text-gray-400" style={{ fontSize: 12 }}>
                    {headerValue instanceof File
                      ? `${(headerValue.size / 1024).toFixed(0)} KB · PDF`
                      : "PDF Document"}
                  </p>
                </div>
              </div>
            )}

            {/* ── Text Header ── */}
            {headerType === "text" && headerValue && (
              <div className="px-3 pt-3 pb-1">
                <p className="font-bold text-gray-900" style={{ fontSize: 15, lineHeight: 1.4 }}>
                  {headerValue}
                </p>
              </div>
            )}

            {/* ── Body ── */}
            <div className="px-3 pt-2 pb-1">
              <div
                className="text-gray-900 whitespace-pre-wrap break-words"
                style={{ fontSize: 15, lineHeight: 1.45 }}
              >
                {renderBody(bodyText)}
              </div>
            </div>

            {/* ── Footer ── */}
            {footerText && (
              <div className="px-3 pb-1">
                <p className="text-gray-400" style={{ fontSize: 13, lineHeight: 1.4 }}>
                  {footerText}
                </p>
              </div>
            )}

            {/* ── Timestamp ── */}
            <div className="px-3 pb-2 flex items-center justify-end gap-1 mt-0.5">
              <span className="text-gray-400" style={{ fontSize: 12 }}>{time}</span>
              <DoubleCheck />
            </div>

            {/* ── Buttons ── */}
            {hasButton && (
              <div className="border-t border-gray-100">
                {buttonType && buttonType !== "none" && buttonText && (
                  <div className="flex items-center justify-center gap-1.5 py-2.5 border-b border-gray-100 last:border-0">
                    {buttonType === "URL" ? (
                      <ExternalLink className="w-4 h-4 text-[#00a5f4]" />
                    ) : (
                      <Phone className="w-4 h-4 text-[#00a5f4]" />
                    )}
                    <span className="text-[#00a5f4] font-medium" style={{ fontSize: 14 }}>
                      {buttonText}
                    </span>
                  </div>
                )}
                {stopButton && (
                  <div className="flex items-center justify-center gap-1.5 py-2.5">
                    <span style={{ fontSize: 14 }}>🚫</span>
                    <span className="text-[#00a5f4] font-medium" style={{ fontSize: 14 }}>
                      STOP
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Format hint */}
      <div className="flex-shrink-0 px-4 py-2 bg-white border-t border-gray-100 flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full bg-green-400 flex-shrink-0" />
        <p className="text-[11px] text-gray-400">
          Format: <strong className="text-gray-600">*bold*</strong>
          {" · "}<em className="text-gray-600">_italic_</em>
          {" · "}<del className="text-gray-600">~strike~</del>
        </p>
      </div>
    </div>
  );
};

export default WhatsAppTemplatePreview;
